import { LANG } from "@shared/i18n";
import { isStoreApp } from "./platform";

/** Identifiant Apple de l'application (App Store Connect › Informations sur l'app › Identifiant Apple). Vide = bouton App Store masqué. */
const APP_STORE_ID = (import.meta.env.VITE_APP_STORE_ID as string | undefined) || "6826191683";

export const APP_STORE_URL = APP_STORE_ID ? `https://apps.apple.com/${LANG === "en" ? "us" : "fr"}/app/gbc-coach-ia/id${APP_STORE_ID}` : null;
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.neotechrams.gbccoach";

/** Système du téléphone qui visite le site (iPadOS se présente comme un Mac tactile). */
export function mobileOs(): "ios" | "android" | null {
  if (typeof navigator === "undefined") return null;
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return "ios";
  if (/Android/.test(ua)) return "android";
  return null;
}

/** Site ouvert depuis l'écran d'accueil (PWA installée). */
const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || (navigator as Navigator & { standalone?: boolean }).standalone === true;

/** Store à proposer au visiteur sur téléphone, sauf s'il utilise déjà l'application. */
export function storeForThisDevice(): { os: "ios" | "android"; url: string } | null {
  if (isStoreApp || isStandalone()) return null;
  const os = mobileOs();
  const url = os === "ios" ? APP_STORE_URL : os === "android" ? PLAY_STORE_URL : null;
  return os && url ? { os, url } : null;
}
